import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import { px2rem } from '../../../core';
import StyledComponent, { ResponsiveStyle } from '../../../core/StyledComponent';

interface EmptyElementProps extends ResponsiveStyle {
    text: string;
    height?: number;
}

const EmptyElement: FC<EmptyElementProps> = ({ text, xs, height = 34, ...props }) => {
    const theme = useTheme();
    return (
        <StyledComponent
            xs={{
                ...xs,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                color: theme.palette.success.main,
                fontSize: 12,
                fontWeight: 600,
                height: px2rem(height),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontFamily: theme.typography.fontFamily,
            }}
            {...props}
        >
            <StyledComponent xs={{ marginRight: px2rem(2) }}>+</StyledComponent>
            {text}
        </StyledComponent>
    );
};

export default EmptyElement;
